<template>
  <div>
    <div v-if="!this.dialog">
      <span
        class="pointer"
        v-for="(route, index) in routeBack"
        v-bind:key="index"
        v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
        v-on:click="goBack(route, index)">
      <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
      </span>
      <hr>
      <div class="alert alert-warning" v-if="!$online">
        <span>
          <center>
              <v-icon size="25">error</v-icon>
              <b>Bitte stellen Sie eine Internetverbindung her!</b>
              <v-icon size="25">error</v-icon>
          </center>
        </span>
      </div>
      <div class="card">
        <v-progress-linear v-if="loading" color="red" :indeterminate="true"></v-progress-linear>
        <div class="card-header text-xs-inline" id="graphheader">
          <h4 class="card-title">
            {{ title }} {{ subtitle }}
            <v-btn
              flat
              icon
              color="grey"
              id="graphbutton"
              title="Neuen Eintrag erstellen"
              v-on:click="addLog"
            >
              <v-icon size="50">add_circle</v-icon>
            </v-btn>
              <v-btn
              flat
              icon
              color="grey"
              id="graphbutton"
              title="Liste herunterladen"
              v-on:click="download"
            >
              <v-icon size="50">cloud_download</v-icon>
            </v-btn>
          </h4>
          <p class="card-category tablecard" id="subtitle"></p>
          <v-form>
            <v-container class="auswahl">
              <v-layout align-center wrap>
                <v-flex shrink pa-2>
                  <label for="startdate">Startdatum:&nbsp;</label>
                  <input type="date" id="date" v-model="startdate" />
                  &nbsp;&nbsp;&nbsp;
                  <label for="enddate">Enddatum:&nbsp;</label>
                  <input type="date" id="date" v-model="enddate" />
                </v-flex>
                <v-flex pa-2>
                  <v-btn color="grey" v-on:click="fetchData(startdate, enddate)">anzeigen</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>
      </div>
      <div class="table-responsive justify-content-center" v-if="!loading">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="6" class="tableBorder"><v-icon>alarm</v-icon>Laufende Temperaturlogs:</th>
            </tr>
            <tr>
              <th>Anzeigen</th>
              <th>Datum & Uhrzeit</th>
              <th>Artikel & Vorgangsnr.</th>
              <th>Kerntemperatur</th>
              <th>60 min</th>
              <th>120 min</th>
              <th>Artikel entnehmen in</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="progressArticles.length < 1">
              <td colspan="7" style="text-align: center">Es sind keine laufenden Temperaturlogs vorhanden.</td>
            </tr>
            <tr v-for="article in progressArticles" v-bind:key="article.id">
              <td @click="openArticle(article)"><v-icon>search</v-icon></td>
              <td>{{ article.datum | formatDate }} {{ article.uhrzeit }}</td>
              <td>{{ article.artikel }} {{ article.artikelnummer }}</td>
              <td>{{ article.firstTemp }}°C</td>
              <td>
                <span v-if="article.sndTemp !== ''">{{ article.sndTemp }}°C</span>
                <countdown v-else :end-time="new Date(article.firstcntdwn.getTime() + 59*60000)">
                  <span
                    slot="process"
                    slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 10 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                  <span slot="finish" class="timerEnds">Messung nicht durchgeführt!</span>
                </countdown>
              </td>
              <td>
                <span v-if="article.trdTemp === '' && article.sndTemp === ''">-</span>
                <countdown v-else-if="article.trdTemp === '' && article.sndTemp !== ''" :end-time="new Date(article.firstcntdwn.getTime() + 119*60000)">
                  <span
                    slot="process"
                    slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 10 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                  <span slot="finish" class="timerEnds">Messung nicht durchgeführt!</span>
                </countdown>
                <span v-else-if="article.trdTemp !== '' && article.sndTemp !== ''">{{ article.trdTemp }}°C</span>
              </td>
              <td>
                <countdown v-if="article.firstcntdwn !== null" :end-time="new Date(article.firstcntdwn.getTime() + 179*60000)">
                  <span
                    slot="process"
                    slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 30 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                  <span slot="finish" class="timerEnds">Artikel entnehmen!</span>
                </countdown>
                <span v-else >-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-divider/>
      <div class="table-responsive" v-if="!loading">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="6" class="tableBorder"><v-icon>alarm_off</v-icon>Abgeschlossen:</th>
            </tr>
            <tr>
              <th>Anzeigen</th>
              <th>Datum & Uhrzeit</th>
              <th>Artikel & Vorgangsnr.</th>
              <th>Bemerkung</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in completedArticles" v-bind:key="article.id">
              <td><v-icon @click="openArticle(article)">search</v-icon></td>
              <td>{{ article.datum | formatDate }} {{ article.uhrzeit }}</td>
              <td>{{ article.artikel }} {{ article.artikelnummer }}</td>
              <td v-if="article.sold === 1">verkauft</td>
              <td v-else-if="article.ruined === 1">entfernt</td>
              <td v-if="article.sold !== 1 && article.ruined !== 1">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="this.dialog">
      <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen hide-overlay>
          <div class="alert alert-warning" v-if="!$online">
            <span>
              <center>
                  <v-icon size="25">error</v-icon>
                  <b>Bitte stellen Sie eine Internetverbindung her!</b>
                  <v-icon size="25">error</v-icon>
              </center>
            </span>
          </div>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title 
                v-if="logArticle.sndTemp === '' &&
                      logArticle.trdTemp === '' &&
                      logArticle.sold    === 0  &&
                      logArticle.ruined  === 0"
              >
              Temperaturlog {{ logArticle.artikel }} {{ logArticle.artikelnummer }} nach 60 min
              (Kategorie: <span v-if="logArticle.artikelkategorie === 1 || logArticle.artikelkategorie === 'Hähnchen'">Hähnchen</span>
               <span v-if="logArticle.artikelkategorie === 2 || logArticle.artikelkategorie === 'Schwein'">Schwein</span>
               <span v-if="logArticle.artikelkategorie === 3 || logArticle.artikelkategorie === 'Sonstige'">Sonstige</span>)
              </v-toolbar-title>
              <v-toolbar-title v-if="logArticle.sndTemp !== '' && logArticle.trdTemp === '' && logArticle.sold === 0 && logArticle.ruined === 0">Temperaturlog {{ logArticle.artikel }} {{ logArticle.artikelnummer }} nach 120 min ({{ logArticle.artikelkategorie }})</v-toolbar-title>
              <v-toolbar-title v-if="logArticle.sold === 1 || logArticle.ruined === 1">Temperaturlog {{ logArticle.artikel }} {{ logArticle.artikelnummer }} vom {{ logArticle.datum | formatDate }} ({{ logArticle.artikelkategorie }})</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <card id="frame">
              <div class="table-responsive justify-content-center">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Messung</th>
                      <th>Datum & Uhrzeit</th>
                      <th>Temperatur</th>
                      <th>Prüfer</th>
                      <th>Bemerkung</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- -------------- -->
                    <!-- Kerntemperatur -->
                    <!-- -------------- -->
                    <tr v-if="logArticle.firstTemp !== ''">
                      <td>Kerntemperatur</td>
                      <td>{{ logArticle.datum | formatDate }} {{ logArticle.uhrzeit }}</td>
                      <td>{{ logArticle.firstTemp }}°C</td>
                      <td>{{ logArticle.firstName }}</td>
                      <td>{{ logArticle.firstBemerkung }}</td>
                    </tr>
                    <tr v-else>
                      <td>Kerntemperatur</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <!-- -------------- -->
                    <!-- 60 min Messung -->
                    <!-- -------------- -->
                    <tr v-if="logArticle.sndTemp !== ''">
                      <td>60 min</td>
                      <td>{{ logArticle.sndTime | formatDate }} {{ logArticle.sndTime | formatTime }}</td>
                      <td>{{ logArticle.sndTemp }}°C</td>
                      <td>{{ logArticle.sndName }}</td>
                      <td>{{ logArticle.sndBemerkung }}</td>
                    </tr>
                    <tr v-else>
                      <td>60 min</td>
                      <td colspan="4">
                        <span v-if="logArticle.sndTemp === '' && (logArticle.sold !== 0 || logArticle.ruined !== 0)">-</span>
                        <countdown v-else :end-time="new Date(logArticle.firstcntdwn.getTime() + 59*60000)">
                          <span
                            slot="process"
                            slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 10 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                          <span slot="finish" class="timerEnds">Messung nicht durchgeführt!</span>
                        </countdown>
                      </td>
                    </tr>
                    <!-- --------------- -->
                    <!-- 120 min Messung -->
                    <!-- --------------- -->
                    <tr v-if="logArticle.trdTemp !== ''">
                      <td>120 min</td>
                      <td>{{ logArticle.trdTime | formatDate }} {{ logArticle.trdTime | formatTime }}</td>
                      <td>{{ logArticle.trdTemp }}°C</td>
                      <td>{{ logArticle.trdName }}</td>
                      <td>{{ logArticle.trdBemerkung }}</td>
                    </tr>
                    <tr v-else>
                      <td>120 min</td>
                      <td colspan="4">
                        <span v-if="logArticle.trdTemp === '' && (logArticle.sold !== 0 || logArticle.ruined !== 0)">-</span>
                        <countdown v-else :end-time="new Date(logArticle.firstcntdwn.getTime() + 119*60000)">
                          <span
                            slot="process"
                            slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 10 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                          <span slot="finish" class="timerEnds">Messung nicht durchgeführt!</span>
                        </countdown>
                      </td>
                    </tr>
                    <!-- ---------------------------------- -->
                    <!-- Countdown verkaufen oder entfernen -->
                    <!-- ---------------------------------- -->
                    <tr v-if="logArticle.firstcntdwn !== null && logArticle.sndTime !== '' && logArticle.sold === 0 && logArticle.ruined === 0">
                      <td>Artikel entfernen in</td>
                      <td>
                        <countdown :end-time="new Date(logArticle.firstcntdwn.getTime() + 179*60000)">
                        <span
                          slot="process"
                          slot-scope="cntdwn" :class="[cntdwn.timeObj.ceil.m < 30 ? 'timerEnds' : '']">{{ cntdwn.timeObj.ceil.m + ':' + cntdwn.timeObj.s + ' min'}}</span>
                        <span slot="finish" class="timerEnds">Artikel entnehmen!</span>
                        </countdown>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">
                        Artikel wurde am {{ logArticle.timeSoldRuined | formatDate }} um {{ logArticle.timeSoldRuined | formatTime }} Uhr 
                        <span v-if="logArticle.sold === 1">verkauft.</span>
                        <span v-if="logArticle.ruined === 1">entfernt.</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </card>
            <v-divider></v-divider>
            <div id="frame" v-if="logArticle.sold === 0 && logArticle.ruined === 0">
              <div v-if="this.tick === 1">
                <card v-if="logArticle.sndTemp === '' && logArticle.trdTemp === ''" :title="'60 min Temp. messen'" id="frame" class="card--center">
                  <button class="btn btn-success" v-on:click="nextTick(0)" type="button">bestätigen</button>
                </card>
                <card v-if="logArticle.sndTemp !== '' && logArticle.trdTemp === ''" :title="'120 min Temp. messen'" id="frame" class="card--center">
                  <button class="btn btn-success" v-on:click="nextTick(0)" type="button">bestätigen</button>
                </card>
                <card :title="logArticle.artikel + ' ausverkauft?'" id="frame" class="card--center">
                  <button v-if="!tmpSold" class="btn btn-warning" v-on:click="tmpSold = !tmpSold" type="button">bestätigen</button>
                  <button v-if="tmpSold" class="btn btn-danger" v-on:click="tmpSold = !tmpSold" type="button">abbrechen</button>
                  <button v-if="tmpSold" class="btn btn-success" v-on:click="save(0, logArticle)" type="button">bestätigen</button>
                </card>
                <card :title="logArticle.artikel + ' entfernt?'" id="frame" class="card--center">
                  <button v-if="!tmpRuined" class="btn btn-warning" v-on:click="tmpRuined = !tmpRuined" type="button">bestätigen</button>
                  <button v-if="tmpRuined" class="btn btn-danger" v-on:click="tmpRuined = !tmpRuined" type="button">abbrechen</button>
                  <button v-if="tmpRuined" class="btn btn-success" v-on:click="save(1, logArticle)" type="button">bestätigen</button>
                </card>
                <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(0)" type="button">zurück</button>
              </div>
              <card v-if="this.tick === 2" :title="tmpTitle" id="frame">
                <form>
                  <v-text-field
                    v-model="tmpDate"
                    label="Datum"
                    type="date"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="tmpTime"
                    label="Uhrzeit"
                    type="time"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="logArticle.artikel"
                    label="Artikel"
                    readonly
                  ></v-text-field>
                  <v-text-field
                      v-model="tmpName"
                      :error-messages="nameErrors"
                      label="Ihr Name"
                      @input="$v.tmpName.$touch()"
                      @blur="$v.tmpName.$touch()"
                      required
                      clearable
                      @click:clear="clearName()"
                  ></v-text-field>
                  <v-text-field
                      v-model="tmpTemperatur"
                      :error-messages="temperaturErrors"
                      label="Temperatur"
                      type="number"
                      step="0.1"
                      @input="$v.tmpTemperatur.$touch()"
                      @blur="$v.tmpTemperatur.$touch()"
                  ></v-text-field>
                  <v-text-field
                      v-model="tmpBemerkung"
                      :label="bemerkungLabel"
                      required
                      v-on:keyup.enter="nextTick(1)"
                  ></v-text-field>
                  <v-divider/>
                  <!-- <v-btn @click="submit">submit</v-btn> -->
                  <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(1)" type="button">abbrechen</button>
                  <button class="btn btn-lg btn-success float-right" v-on:click="nextTick(1)" type="button">weiter</button>
                </form>
              </card>
              <card :title="title2" v-if="tick === 3" id="frame">
                <hr>
                <!-- bestätigen --> 
                <div class="angaben">
                    <p>Artikel: {{ logArticle.artikel }}</p>
                    <p>Datum: {{ transformDate(tmpDate) }}</p>
                    <p>Uhrzeit: {{ transformTime(tmpTime) }}</p>
                    <p>Ihr Name: {{ tmpName }}</p>
                    <p>Temperatur: {{ tmpTemperatur }}°C</p>
                    <p>Bemerkung: {{ tmpBemerkung }}</p>
                </div>
                <hr>
                <div>
                  <button class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>
                  <button class="btn btn-lg btn-success float-right" v-on:click="save(2, logArticle)" type="button">bestätigen</button>
                </div>
              </card>
              <div class="alert alert-success" v-if="tick === 4" id="alert">
                <!-- Erfoglsmeldung -->
                <button type="button" aria-hidden="true" class="close"></button>
                <span>
                <b>Erfolgreich bearbeitet! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
              </div>
            </div>
            <div id="frame" v-if="(logArticle.sold === 1 || logArticle.ruined === 1) && tick !== 4">
              <card id="frame">
                <div>
                  <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(0)" type="button">zurück</button>
                </div>
              </card>
            </div>
            <div id="frame" v-if="(logArticle.sold === 1 || logArticle.ruined === 1) && tick === 4">
              <card id="frame">
                <div class="alert alert-success" id="alert">
                  <!-- Erfoglsmeldung -->
                  <button type="button" aria-hidden="true" class="close"></button>
                  <span>
                  <b>Erfolgreich bearbeitet! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
                </div>
              </card>
            </div>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { numeric, required, alphaNum } from "vuelidate/lib/validators"
import { helpers } from "vuelidate/lib/validators"
import navigation from "../../../../store/navigation"

export const alphaDiacritic = helpers.regex("alphaDiacritic", /^[a-zA-ZÀ-ž ]*$/)

export default {
    mixins: [validationMixin],

    validations: {
        tmpName: { required, alphaDiacritic },
        tmpTemperatur: { required }
    },
    data() {
        return {
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,

            tmpTemperatur: "",
            tmpBemerkung: "",
            tmpDate: "",
            tmpTime: "",
            tmpTimeToSave: "",
            tmpTitle: "",
            tmpName: "",
            tick: 1,
            tmpTick: null,
            entfBemerkung: "",
            title2: "Angaben bestätigen",
            loading: false,

            tmpSold: false,
            tmpRuined: false,

            startup: 1,
            upload: false,
            showAlarm: false,
            showSuccess: false,
            uploadAnzahl: 0,
            uploadZaehler: 0,
            routeBack: [],
            addIndex: null,
            title: "Heiße Theke - Temperaturlogs",
            subtitle: "",
            bereichID: undefined,
            checkDate: false,
            startdate: "",
            enddate: "",
            auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
            completedArticles: [],
            progressArticles: [],
            logArticle: [],
            bemerkungLabel: "Bemerkung",

            dst: [
                { year: 2019, start: "2019-03-31", ende: "2019-10-27" },
                { year: 2020, start: "2020-03-29", ende: "2020-10-25" },
                { year: 2021, start: "2021-03-28", ende: "2021-10-31" },
                { year: 2022, start: "2022-03-27", ende: "2022-10-30" },
                { year: 2023, start: "2023-03-26", ende: "2023-10-29" },
                { year: 2024, start: "2024-03-31", ende: "2024-10-27" },
                { year: 2025, start: "2025-03-30", ende: "2025-10-26" },
                { year: 2026, start: "2026-03-29", ende: "2026-10-25" },
                { year: 2027, start: "2027-03-28", ende: "2027-10-31" },
                { year: 2028, start: "2028-03-26", ende: "2028-10-29" },
                { year: 2029, start: "2029-03-25", ende: "2029-10-28" }
            ]
        }
    },
    methods: {
        goBack(route) {
            if (route !== "heissetheke") {
                this.$router.push({ path: navigation.createNav(route).path })
            }
        },
        download() {
            let data = this.progressArticles.concat(this.completedArticles)
            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/json2xls", { data: data, area: this.title }).then(function(response) {
                window.location = process.env.VUE_APP_NODE_API_URL + response.body
            })
        },
        cancel(check) {
            if (check === 0) {
                this.tick = 1
                this.dialog = false
                this.tmpSold = false
                this.tmpRuined = false
            } else if (check === 1) {
                this.tick = 1
                this.tmpBemerkung = ""
                this.tmpName = ""
                this.tmpTemperatur = ""
            } else {
                this.tick = this.tmpTick
            }
        },
        disableNotification() {
            this.showAlarm = false
            this.showSuccess = false
        },
        pushChecklist(id, tempID) {
            if (id) {
                this.$router.push({ path: this.subtitle.toLowerCase() + "/checklist/" + id, query: { title: this.$route.query.title, routeBack: this.routeBack, bereichID: Number(this.bereichID) } })
            } else {
                id = -1
                this.$router.push({
                    path: this.subtitle.toLowerCase() + "/checklist/" + id,
                    query: { title: this.$route.query.title, routeBack: this.routeBack, bereichID: Number(this.bereichID), tempID: tempID }
                })
            }
        },
        addLog() {
            this.$router.push({ path: "heissetheke/add/", query: { title: this.$route.query.title, routeBack: this.routeBack } })
        },
        openArticle(article) {
            this.logArticle = article
            if (article.sndTemp === "" && article.trdTemp === "" && article.sold === 0 && article.ruined === 0) {
                this.tmpTitle = "Temperaturlog nach 60 Minuten"
            } else if (article.sndTemp !== "" && article.trdTemp === "" && article.sold === 0 && article.ruined === 0) {
                this.tmpTitle = "Temperaturlog nach 120 Minuten"
            }
            this.dialog = true
        },
        nextTick(check) {
            if (check !== 0) {
                this.tmpTick = this.tick
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    if (+this.tmpTemperatur < 65 && _.isEmpty(this.bemerkung)) {
                        this.bemerkungLabel = "Temp. zu niedrig! Bitte Bemerkung hinterlegen!"
                    } else {
                        this.tick++
                    }
                }
            } else {
                var today = new Date()
                var dd = String(today.getDate()).padStart(2, "0")
                var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
                var yyyy = today.getFullYear()
                var date = yyyy + "-" + mm + "-" + dd
                this.tmpTimeToSave = today
                this.tmpDate = date

                //DST check
                var thisYear = yyyy
                var dstEnd
                var dstStart
                for (var i = 0; i < this.dst.length; i++) {
                    if (this.dst[i].year == thisYear) {
                        dstEnd = new Date(this.dst[i].ende)
                        dstStart = new Date(this.dst[i].start)
                    }
                }

                if (new Date(date) < dstEnd && new Date(date) >= dstStart) {
                    const tmpHour = today.getUTCHours() + 2 < 10 ? "0" + (today.getUTCHours() + 2) : today.getUTCHours() + 2
                    if (+today.getUTCMinutes() < 10) {
                        this.tmpTime = tmpHour + ":0" + today.getUTCMinutes()
                    } else {
                        this.tmpTime = tmpHour + ":" + today.getUTCMinutes()
                    }
                } else {
                    const tmpHour = today.getUTCHours() + 1 < 10 ? "0" + (today.getUTCHours() + 1) : today.getUTCHours() + 1
                    if (+today.getUTCMinutes() < 10) {
                        this.tmpTime = tmpHour + ":0" + today.getUTCMinutes()
                    } else {
                        this.tmpTime = tmpHour + ":" + today.getUTCMinutes()
                    }
                }
                this.tmpTick = this.tick
                this.tick++
            }
        },
        transformDate(date) {
            var today = new Date(date)
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()

            var newdate = dd + "." + mm + "." + yyyy
            return newdate
        },
        transformTime(time) {
            var tranformedTime = time.substring(0, 5)
            return tranformedTime
        },
        startupFetch() {
            this.loading = true
            var today = new Date()
            // today.setDate(today.getDate() - 7);
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()

            var startdate = yyyy + "-" + mm + "-" + dd
            this.startdate = startdate

            var weekAgo = new Date()
            var dd1 = String(weekAgo.getDate()).padStart(2, "0")
            var mm1 = String(weekAgo.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy1 = weekAgo.getFullYear()
            var enddate = yyyy1 + "-" + mm1 + "-" + dd1
            this.enddate = enddate
            this.fetchData(this.startdate, this.enddate)
        },
        fetchData(start, end) {
            if (start <= end) {
                console.log("Abrufen der Logs aus der DB")
                try {
                    this.progressArticles = []
                    this.completedArticles = []
                    /******************
                     * Processing Items:
                     ******************/
                    this.$http
                        .get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/heissetheke/processing/" + start + "&" + end, { headers: { Authorization: this.auth } })
                        .then(function(response) {
                            if (response.body.data.length > 0) {
                                this.setProgressList(response.body.data)
                            }
                            this.loading = false
                        })
                        .catch((e) => {
                            e.body === "" ? (this.progressArticles = "") : ""
                        })
                    /******************
                     * Done Items:
                     ******************/
                    this.$http
                        .get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/heissetheke/done/" + start + "&" + end, { headers: { Authorization: this.auth } })
                        .then(function(response) {
                            if (response.body.data.length > 0) {
                                this.setCompletedList(response.body.data)
                            }
                            this.loading = false
                        })
                        .catch((e) => {
                            e.body === "" ? (this.completedArticles = "") : ""
                        })
                } catch (e) {
                    console.log(e)
                }
            }
        },
        setProgressList(list) {
            list.map((article) => {
                article.uhrzeit = article.uhrzeit.slice(0, 5)
                switch (article.artikelkategorie) {
                    case 1:
                        article.artikelkategorie = "Hähnchen"
                        break
                    case 2:
                        article.artikelkategorie = "Schwein"
                        break
                    case 3:
                        article.artikelkategorie = "Sonstige"
                        break
                    default:
                        break
                }
                article.firstcntdwn = new Date(article.firstTime)
                this.progressArticles.push(article)
            })
        },
        setCompletedList(list) {
            list.map((article) => {
                article.uhrzeit = article.uhrzeit.slice(0, 5)
                switch (article.artikelkategorie) {
                    case 1:
                        article.artikelkategorie = "Hähnchen"
                        break
                    case 2:
                        article.artikelkategorie = "Schwein"
                        break
                    case 3:
                        article.artikelkategorie = "Sonstige"
                        break
                    default:
                        break
                }
                this.completedArticles.push(article)
            })
        },
        save(check, article) {
            this.tick = 4
            // check === 0 -> Artikel wurde verkauft
            // check === 1 -> Artikel wurde entfernt
            // check === 2 -> Temperaturlog 60 / 120 min wurde angelegt
            if (check === 0) {
                article.sold = 1
                article.timeSoldRuined = new Date()
                this.uploadCompletedArticle(article)
            } else if (check === 1) {
                article.ruined = 1
                article.timeSoldRuined = new Date()
                this.uploadCompletedArticle(article)
            } else if (check === 2) {
                let tmpDate = new Date(this.tmpDate)
                tmpDate.setHours(+this.tmpTime.slice(0, 2), +this.tmpTime.slice(3, 5))
                switch (article.stufe) {
                    case 0:
                        article.sndTemp = this.tmpTemperatur
                        article.sndName = this.tmpName
                        article.sndBemerkung = this.tmpBemerkung
                        article.sndTime = tmpDate
                        article.stufe = 1
                        this.uploadProgressArticle(article)
                        break
                    case 1:
                        article.trdTemp = this.tmpTemperatur
                        article.trdName = this.tmpName
                        article.trdBemerkung = this.tmpBemerkung
                        article.trdTime = tmpDate
                        article.stufe = 2
                        this.uploadProgressArticle(article)
                        break
                }
            }
        },
        uploadProgressArticle(article) {
            const time = article.stufe === 1 ? "60min" : "120min"
            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/heissetheke/log/update/" + time, article, { headers: { Authorization: this.auth } }).then(function(response) {
                if (response.body.error) {
                    console.log(response.body.error)
                    this.showAlarm = true
                } else {
                    this.showSuccess = true
                    this.fetchData(this.startdate, this.enddate)
                    setTimeout(() => {
                        this.tmpBemerkung = ""
                        this.tmpName = ""
                        this.tmpTemperatur = ""
                        this.dialog = false
                        this.tick = 1
                        this.tmpSold = false
                        this.tmpRuined = false
                    }, 1500)
                }
            })
        },
        uploadCompletedArticle(article) {
            const reason = article.sold === 1 ? "sold" : "ruined"
            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/heissetheke/log/update/" + reason, article, { headers: { Authorization: this.auth } }).then(function(response) {
                if (response.body.error) {
                    console.log(response.body.error)
                    this.showAlarm = true
                } else {
                    this.showSuccess = true
                    this.tick = 4
                    this.fetchData(this.startdate, this.enddate)
                    setTimeout(() => {
                        this.tmpBemerkung = ""
                        this.tmpName = ""
                        this.tmpTemperatur = ""
                        this.dialog = false
                        this.tick = 1
                        this.tmpSold = false
                        this.tmpRuined = false
                    }, 1500)
                }
            })
        }
    },
    computed: {
        nameErrors() {
            const errors = []
            if (!this.$v.tmpName.$dirty) return errors
            !this.$v.tmpName.required && errors.push("Bitte geben Sie Ihren Namen ein")
            !this.$v.tmpName.alphaDiacritic && errors.push("Bitte keine Sonderzeichen eingeben")
            return errors
        },
        temperaturErrors() {
            const errors = []
            if (this.active) {
                if (!this.$v.tmpTemperatur.$dirty) return errors
                !this.$v.tmpTemperatur.required && errors.push("Temperatur muss angegeben werden")
                return errors
            } else {
                return errors
            }
        }
    },
    created: function() {
        this.routeBack = navigation.createNav("heissetheke").params
        if (this.$route.query) {
            this.subtitle = this.$route.query.subtitle
            this.bereichID = this.$route.query.bereichID
        }

        this.startupFetch()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;
}

.card--center {
    text-align: center;
}

#date {
    margin-bottom: 10px;
    padding: 5px;
    border: 2px solid rgb(117, 108, 108);
    border-radius: 5px;
}
.auswahl {
    padding: 3px 3px 10px 3px !important;
}
.backBar:hover {
    cursor: pointer;
    text-decoration: underline;
    color: red;
}

.timerEnds {
    color: red;
}

.pointer {
    cursor: default;
}

.tableBorder {
    border-top: unset;
}

.angaben {
    font-size: large;
    font-weight: bold;
}
</style>
